import axios from 'Axios';
import {
  ticketBasicRoute,
  ticketRoute,
  ticketDraftRoute,
  ticketRouteDelete,
  ticketRouteToggleFavorite,
} from '../api/Routes';

import { getProjects } from 'Actions/projectActions';

function getCurrentProjectStart() {
  return {
    type: 'GET_CURRENT_PROJECT_START',
  };
}

function getCurrentProjectDone(data) {
  return {
    type: 'GET_CURRENT_PROJECT_DONE',
    tickets: data.tickets,
    currentProject: data.project,
    slipAnalytics: data.slipAnalytics,
  };
}
function deleteTicketStart() {
  return {
    type: 'DELETE_TICKET_START',
  };
}

function deleteTicketDone(data, ticketId) {
  return {
    type: 'DELETE_TICKET_DONE',
    deletedTicket: ticketId,
    data: data,
  };
}
function createTicketStart() {
  return {
    type: 'CREATE_TICKET_START',
  };
}

function createTicketDone(data) {
  return {
    type: 'CREATE_TICKET_DONE',
    createdTicket: data,
  };
}
function createDraftTicketStart() {
  return {
    type: 'CREATE_DRAFT_TICKET_START',
  };
}

function createDraftTicketDone(data) {
  return {
    type: 'CREATE_DRAFT_TICKET_DONE',
    createdTicket: data,
  };
}
function getCurrentTicketStart() {
  return {
    type: 'GET_CURRENT_TICKET_START',
  };
}

function getCurrentTicketDone(data) {
  const mounting = data.criteriaValues.find(cv => cv.id === 2);
  const mountingPositionCriteria = mounting
    ? mounting.criteria.find(c => c.id === 15)
    : false;
  const mountingTypeCriteria = mounting
    ? mounting.criteria.find(c => c.id === 16)
    : false;
  const mountingPosition = mountingPositionCriteria
    ? mountingPositionCriteria.criteria.find(c => c.checked).id
    : false;
  const mountingType = mountingTypeCriteria
    ? mountingTypeCriteria.criteria.find(c => c.checked).id
    : false;
  const currentTicketData =
    mountingPosition && mountingType
      ? { ...data, mountingPosition, mountingType }
      : data;
  return {
    type: 'GET_CURRENT_TICKET_DONE',
    currentTicket: currentTicketData,
  };
}
function editTicketStart() {
  return {
    type: 'EDIT_TICKET_START',
  };
}
function editTicketDone(data) {
  return {
    type: 'EDIT_TICKET_DONE',
  };
}
function favoriteTicketStart() {
  return {
    type: 'FAVORITE_TICKET_START',
  };
}
function favoriteTicketDone(ticketId) {
  return {
    type: 'FAVORITE_TICKET_DONE',
    ticketId,
  };
}
function ticketsError(errorMessage) {
  return {
    type: 'TICKETS_ERROR',
    errorMessage,
  };
}
export const getCurrentProject = projectId => {
  return function(dispatch) {
    dispatch(getCurrentProjectStart());

    axios
      .get(ticketBasicRoute(projectId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getCurrentProjectDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(ticketsError(errorMessage));
      });
  };
};
export const deleteTicket = (projectId, ticketId) => {
  return function(dispatch) {
    dispatch(deleteTicketStart());

    axios
      .delete(ticketRouteDelete(projectId, ticketId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(deleteTicketDone(data, ticketId));
        dispatch(getProjects());
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(ticketsError(errorMessage));
      });
  };
};

export const createTicket = (projectId, ticketObject, history) => {
  return function(dispatch) {
    dispatch(createTicketStart());

    axios
      .post(ticketBasicRoute(projectId), ticketObject)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;
        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(createTicketDone(data));
        history.push(`/demand/project/${projectId}`);
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(ticketsError(errorMessage));
      });
  };
};

export const createDraftTicket = (projectId, ticketObject, history) => {
  return function(dispatch) {
    dispatch(createDraftTicketStart());

    axios
      .post(ticketDraftRoute(projectId), ticketObject, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(response => {
        // If request is good...
        const { status, statusText } = response;
        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(createDraftTicketDone(data));
        history.push(`/demand/project/${projectId}`);
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(ticketsError(errorMessage));
      });
  };
};

export const getCurrentTicket = (projectId, ticketId) => {
  return function(dispatch) {
    dispatch(getCurrentTicketStart());

    axios
      .get(ticketRoute(projectId, ticketId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getCurrentTicketDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(ticketsError(errorMessage));
      });
  };
};

export const editTicket = (projectId, ticketId, ticketObject, history) => {
  return function(dispatch) {
    dispatch(editTicketStart());

    axios
      .post(ticketRoute(projectId, ticketId), ticketObject, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(response => {
        // If request is good...
        const { status, statusText } = response;
        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(editTicketDone(data));
        history.push(`/demand/project/${projectId}`);
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(ticketsError(errorMessage));
      });
  };
};

export const toggleTicketFavorite = (projectId, ticketId) => {
  return function(dispatch) {
    dispatch(favoriteTicketStart());

    axios
      .put(
        ticketRouteToggleFavorite(projectId, ticketId),
        {},
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      )
      .then(response => {
        // If request is good...
        const { status, statusText } = response;
        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(() => {
        dispatch(favoriteTicketDone(ticketId));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(ticketsError(errorMessage));
      });
  };
};
